import utils from "@/api/utils";

class GeoServer {
  constructor(api) {
    this.api = api;
  }

  getData(data, isNetwork, onSuccess, onError) {
    let filter = isNetwork ? "/network" : "";
    return this.api.http_fibercloud
      .post("v1/geoserver" + filter, data, {
        headers: utils.getHeaders()  
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getImage(data, workspaceUUID, token, isNetwork, onSuccess, onError) {
    let headers = { companyuuid: utils.getCompanyUUID() };
    if (workspaceUUID) {
      headers.workspaceuuid = workspaceUUID;
    }

    let filter = isNetwork ? "/network" : "";

    return this.api.http_fibercloud
      .post("v1/geoserver" + filter, data, {
        cancelToken: token,
        responseType: "arraybuffer",
        headers: headers
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

}

export default GeoServer;



// WEBPACK FOOTER //
// ./src/api/geo_server.js